<template>
	<div class="mt6 xs-12 wrap">
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("Fact Type") }}</div>
		<j-base-select :options="options" v-model="factType" @input="initInputValue" />
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("Label") }}</div>
		<j-base-input-text size="medium" v-model="inputType" @input="onInputChange" />
		<div v-if="factType" class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("value") }}</div>
		<j-base-toggle
			v-if="factType == 'booleanValue'"
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
		<j-base-date-picker-simple
			v-if="factType == 'dateValue'"
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
		<j-base-input-number
			v-if="factType == 'numberValue'"
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
		<j-input-list
			v-if="factType == 'arrayValue'"
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
		<j-base-input-text
			v-if="factType == 'stringValue'"
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JBaseSelect from "@/components/JBaseSelect"
import JBaseToggle from "@/components/JBaseToggle"
import JBaseInputNumber from "@/components/JBaseInputNumber"
import JInputList from "@/components/JInputList"
import JBaseDatePickerSimple from "@/components/JBaseDatePickerSimple"

export default {
	name: "InputNewFact",
	components: {
		JBaseInputText,
		JBaseInputNumber,
		JBaseToggle,
		JInputList,
		JBaseSelect,
		JBaseDatePickerSimple
	},
	props: {
		value: {
			required: false
		}
	},
	data() {
		return {
			inputValue: "",
			inputType: "",
			factType: "",
			options: [
				{ name: "Text", value: "stringValue" },
				{ name: "Number", value: "numberValue" },
				{ name: "Boolean", value: "booleanValue" },
				{ name: "Date", value: "dateValue" },
				{ name: "List", value: "arrayValue" }
			]
		}
	},

	methods: {
		onInputChange() {
			this.$emit("input", {
				type: this.inputType,
				value: {
					[this.factType]: this.inputValue
				}
			})
		},
		initInputValue() {
			this.inputValue =
				this.factType == "arrayValue"
					? [{}]
					: this.factType == "booleanValue"
					? false
					: ""
		}
	}
}
</script>
